import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { BetNotificationWr, freeBetStore, loadingStore, SlowConnectionWr } from '@pascal/pascal-core';

import { BetBlock } from '../common';
import { delay } from '../../helpers/delay';
import { gameDrawer } from '../../gameDrawer';
import { minOdd } from '../../components/common/betPlaceInfo';
import { dancerAnimations } from '../../services/DancerAnimations';

const WebGame = observer(() => {
  const game = useRef(null);
  const { activeFreeBet } = freeBetStore;
  const [clickEnd, setClickEnd] = useState(true);

  const pushChest = () => {
    if (clickEnd) {
      setClickEnd(false);
      dancerAnimations.startPushAnimation();
      delay(() => {
        setClickEnd(true);
      }, 1000);
    }
  };

  useEffect(() => {
    gameDrawer.execute(game.current).then(() => {
      loadingStore.updateLoading({ isPixiLoaded: true });
    });
  }, []);

  return (
    <>
      <BetNotificationWr
        translationDynamicValues={{ value: `x${activeFreeBet.id ? activeFreeBet?.minOdd : minOdd}` }}
      />
      <SlowConnectionWr />
      <div className='for-chest' onClick={pushChest} />
      <div className='game-container' ref={game} />
      <BetBlock />
    </>
  );
});

export default WebGame;
